import React from "react";
import { Navigate } from "react-router-dom";


const ProtectedRoute = ({ component: Component, ...rest }) => {

  let userDetails = localStorage.getItem("userDetails");
  userDetails = JSON.parse(userDetails);
  const isAuthenticated = !!userDetails?.accessToken;

 
const renderComponent = () => {
    if (isAuthenticated) {
      return <Component {...rest} />;
    } 
    else {
      return <Navigate to="/" />;
    }
  };

  return renderComponent();
};
export default ProtectedRoute;



